/** Runtime configuration derived from Vite env vars. */

function trimTrailingSlash(url: string): string {
  return url.replace(/\/+$/, "");
}

/**
 * Origin of the DRF API, e.g. http://localhost:5010 (no trailing slash, no path).
 *
 * The generated OpenAPI schema (drf-spectacular) emits absolute paths that
 * already include the `/api/v1/` prefix (e.g. `/api/v1/auth/token/`), so the
 * openapi-fetch client is configured with the bare origin and the typed paths
 * carry the prefix. A legacy `…/api/v1` suffix on VITE_API_URL is tolerated and
 * stripped so both conventions work.
 */
export const API_ORIGIN = trimTrailingSlash(
  import.meta.env.VITE_API_URL ?? "http://localhost:5010",
).replace(/\/api\/v\d+$/, "");

/**
 * Origin of the Django-served account pages (signup, password reset) that the
 * SPA links out to — these flows are not part of the SPA. Defaults to the local
 * app domain; set VITE_ACCOUNTS_URL per environment (e.g. https://app.activateur.ca).
 */
export const ACCOUNTS_ORIGIN = trimTrailingSlash(
  import.meta.env.VITE_ACCOUNTS_URL ?? "http://app.activateur.local:5000",
);
